import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { loadStore } from "store";
var LoginView = /** @class */ (function (_super) {
    tslib_1.__extends(LoginView, _super);
    function LoginView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.email = null;
        _this.pin = null;
        _this.requestPin = false;
        _this.loginDisabled = true;
        _this.errorMessage = "";
        return _this;
    }
    LoginView.prototype.emailChanged = function () {
        this.errorMessage = "";
        if (this.loading || this.email.length == 0)
            this.loginDisabled = true;
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.loginDisabled = !pattern.test(this.email);
    };
    LoginView.prototype.sendPin = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var requestPIN;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, axios.get("user/requestpin", { params: { email: this.email } })];
                    case 1:
                        requestPIN = (_a.sent()).data;
                        if (!requestPIN) {
                            this.errorMessage = this.$t("loginView.errorEmail").toString();
                        }
                        else {
                            this.requestPin = true;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    LoginView.prototype.login = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, axios.post("user/login", { email: this.email, pin: this.pin })];
                    case 1:
                        data = (_a.sent()).data;
                        if (!(data == "Invalid PIN")) return [3 /*break*/, 2];
                        this.errorMessage = this.$t("loginView.errorPin").toString();
                        return [3 /*break*/, 4];
                    case 2:
                        localStorage.setItem("sessionToken", data);
                        return [4 /*yield*/, loadStore()];
                    case 3:
                        _a.sent();
                        this.$router.push("/");
                        _a.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        if (window.console)
                            console.log("userLogin", err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LoginView = tslib_1.__decorate([
        Component
    ], LoginView);
    return LoginView;
}(Vue));
export default LoginView;
